import styles from '../styles.module.css'

export default function UnavailableOrOutOfStock(props) {
  const {isOutOfStock, availabilityAt} = props.product
  const {notAvailableMessage} = availabilityAt
  const productAvailability = isOutOfStock ? 'fields.outOfStock' : 'fields.notAvailable'

  if ((availabilityAt.available && !isOutOfStock) || notAvailableMessage) return

  return <div className={styles.outOfStock}>{props.t(productAvailability, {ns: 'generic'})}</div>
}
